// import {captureMessage} from '@sentry/react';
import bridgeReal, {ErrorData, RequestPropsMap, VKBridgeSend} from '@vkontakte/vk-bridge';
import bridgeMock from '@vkontakte/vk-bridge-mock';
import {
    isOKClient,
    isUseCustomBridge,
    // parseBridgeError,
} from './utils';
import {isDev} from './constants';
import {captureException} from '@sentry/react';

const addSendCatchToBridge = <T extends typeof bridgeReal>(bridge: T): {sendWithCatch: VKBridgeSend} & T => {
    return {
        ...bridge,
        sendWithCatch: function (...args) {
            return new Promise((resolve, reject) => {
                this.send(...args)
                    .then((result) => {
                        resolve(result);
                    })
                    .catch((e) => {
                        // временно отрубаем ошибки чтоб снизить фон TRG-150596
                        // captureMessage(parseBridgeError(e, args[0]), 'error');
                        reject(e);
                    });
            });
        },
    };
};

// ПРОД-БРИДЖ:
// для сборки miniapp_vk_cdn REACT_APP_IS_BRIDGE_ALLOWED всегда в true
// также если в сборке для кубера приходит флажок use_custom_bridge=1
// и если у нас дев режим, но открываем через туннель на мобиле или вебе

// МОК-БРИДЖ
// для дев сборки вставляем мок-бридж

// БЕЗ БРИДЖА
// в остальных случаях без бриджа

// isEmbedded = isWebView() || isIframe()
export const bridge =
    process.env.REACT_APP_IS_BRIDGE_ALLOWED === 'true' || (isDev && bridgeReal.isEmbedded()) || isUseCustomBridge()
        ? addSendCatchToBridge(bridgeReal)
        : isDev && !bridgeReal.isEmbedded()
        ? addSendCatchToBridge(bridgeMock)
        : null;

export const onCopyToClickboard = (text: string) => {
    return new Promise((resolve, reject) => {
        if (bridge && bridge.supports('VKWebAppCopyText')) {
            bridge
                .sendWithCatch('VKWebAppCopyText', {text})
                .then(resolve, reject)
                .catch(() => {});
        } else {
            try {
                navigator.clipboard.writeText(text).then(resolve, (e) => {
                    captureException(e);
                    reject(e);
                });
            } catch (e) {
                captureException(e);
                reject(e);
            }
        }
    });
};

export const parseBridgeError = (e: ErrorData, event: keyof RequestPropsMap) => {
    let error = `Bridge ${isOKClient() ? 'OK' : 'VK'} error: event: ${event}; `;

    try {
        if (e.error_type === 'client_error') {
            error += `type: ${e.error_type}; code: ${e.error_data.error_code}; reason: ${e.error_data.error_reason}`;
            if (e.error_data.error_description) {
                error += `; error_description: ${e.error_data.error_description}`;
            }
        } else if (e.error_type === 'api_error') {
            error += `type: ${e.error_type}; code: ${e.error_data.error_code}; msg: ${e.error_data.error_msg}`;
            if (e.error_data.request_params) {
                error += `; request_params: ${JSON.stringify(e.error_data.request_params)}`;
            }
        } else if (e.error_type === 'auth_error') {
            error += `type: ${e.error_type}; code: ${e.error_data.error_code} reason: ${e.error_data.error_reason}`;
            if (e.error_data.error_description) {
                error += `; request_params: ${JSON.stringify(e.error_data.error_description)}`;
            }
        } else {
            error += 'failed parse bridge error';
        }
    } catch (e) {
        let message = 'Unknown Error';
        if (e instanceof Error) message = e.message;
        else message = String(e);
        error += ` failed parse errorData; Message: ${message}`;
        captureException(e);
    }

    return error;
};
